module.exports = __webpack_public_path__ + "6ab954a2e159bbff01e319da0d6decea.svg";